import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { EventType, Payload } from '../constants/events';
import { AppEvent } from '../helpers/eventType';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private handler = new Subject<AppEvent<Payload>>();
  constructor() {}

  /**
   * Enviar evento
   * @param type tipo de evento
   * @param payload payload
   */
  broadcast(type: EventType, payload: Payload): void {
    this.handler.next({ type, payload });
  }

  /**
   * Suscribirse a evento
   * @param eventType tipo de evento
   */
  on(eventType: EventType): Observable<AppEvent<Payload>> {
    return this.handler.pipe(filter((event) => event.type === eventType));
  }
}
